module.exports = __webpack_public_path__ + "static/media/filter-clear.dafa199f.svg";